import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_wallet",
  "use": "icon-project_wallet-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_wallet\"><g transform=\"translate(3 2)\"><circle cx=\"15\" cy=\"12\" r=\"1\" /><rect stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" x=\"1\" y=\"1\" width=\"20\" height=\"22\" rx=\"4\" /><path stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linejoin=\"round\" d=\"M21 9h-9v6h9\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol